import React, { useState } from "react";

import VideoCard from "../../components/cards/videoCard";
import LinkedInIcon from "../../images/icons/linked-in.inline.svg";

const TeamCard = ({
  bgImage,
  title,
  memberTitle,
  content,
  sourceUrl,
  memberVideo,
  groupProgram,
  linkedinProfile,
  featuredCard = false,
  contectClass,
  extraVideoClass = "",
  size = "nm"
}) => {
  const featuredImage = bgImage;
  const [readMore, setReadMore] = useState(false);
  const linkName = readMore ? "Read less " : "Read more ";
  const description = content;

  const sizesConfig = {
    nm: featuredCard ? "sm:min-h-60 h-fit" : "sm:min-h-32 h-fit",
    sm: "h-32",
    md: "h-52",
    lg: "h-72"
  };

  return (
    <div
      className={`${
        featuredCard ? "sm:w-full" : "sm:w-80"
      } w-full rounded-xl overflow-hidden shadow-lg cursor-pointer`}
    >
      {(featuredImage || sourceUrl) && !groupProgram?.includes("grouptype") && (
        <VideoCard
          sourceUrl={sourceUrl || featuredImage}
          title={""}
          bgImage={""}
          memberTitle={""}
          featVideos={memberVideo}
          cardClass={` ${sizesConfig[size]} object-cover w-full object-center ${extraVideoClass}`}
        />
      )}
      <div className="p-5 planet:bg-gray-darker bg-secondary-bg h-full">
        <div className="flex items-center">
          {linkedinProfile && (
            <div className="flex justify-center items-center mr-5">
              <a
                href={linkedinProfile}
                rel="noreferrer"
                title={title}
                className=""
                target="_blank"
              >
                <LinkedInIcon className="h-8 w-8 fill-black-lighter planet:fill-white" />
              </a>
            </div>
          )}

          <div className="flex flex-col w-full">
            <h3
              className="lato-400-latin text-base font-normal not-italic m-0 !pb-0"
              dangerouslySetInnerHTML={{
                __html: title
              }}
            />
            {memberTitle && (
              <div
                className={`${
                  featuredCard ? "uppercase" : ""
                } lato-400-latin text-xs font-normal not-italic text-generic-text planet:text-gray-generic pt-1`}
                dangerouslySetInnerHTML={{
                  __html: memberTitle
                }}
              />
            )}
          </div>
        </div>
        {description && (
          <>
            <div
              className={
                contectClass ??
                "lato-400-latin text-base font-normal not-italic text-generic-text planet:text-gray-generic tab-content_html"
              }
              dangerouslySetInnerHTML={{
                __html: readMore
                  ? description
                  : `${description?.substring(0, 180)} ${
                      description?.length > 180 ? "..." : ""
                    }`
              }}
            />
          </>
        )}

        {description?.length > 180 && (
          <div className="flex">
            <button
              className="lato-400-latin text-xs text-left underline text-generic-text planet:text-gray-generic font-normal pt-4"
              onClick={() => setReadMore(!readMore)}
            >
              {linkName}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamCard;
